module.exports = __webpack_public_path__ + "static/media/user2.6ec75435.png";